export default __webpack_public_path__ + "static/SVSU-6931123d19e82b9e1f58d552f245db94.png";